import nProgress from 'nprogress';

const ProgressBar = nProgress.configure({ showSpinner: false });

export default ProgressBar;
